import type { ReactElement } from "react";

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  Rect,
} from "@/crossPlatform/react-native-svg";

const EyeIllustrationSVG = ({
  height,
  width,
}: Partial<SizeDimensions>): ReactElement<Partial<SizeDimensions>, "svg"> => (
  <Svg fill="none" height={height} viewBox="0 0 240 240" width={width}>
    <G clipPath="url(#clip0_5102_19355)">
      <Path
        d="M105.327 225.714C163.925 233.604 217.824 192.496 225.714 133.898C233.604 75.2998 192.497 21.4004 133.899 13.5105C75.3002 5.62062 21.4009 46.728 13.511 105.326C5.62109 163.925 46.7284 217.824 105.327 225.714Z"
        fill="#00EBBF"
      />
      <G clipPath="url(#clip1_5102_19355)">
        <Path
          d="M7.71798 114.404C35.6016 140.209 64.7119 167.251 101.964 178.337C120.273 183.784 138.945 184.872 157.641 180.636C174.518 176.812 191.584 170.202 205.686 160.015C218.71 150.611 228.861 137.745 232.672 121.929C236.764 104.934 226.836 86.4966 214.8 74.9991C202.788 63.5264 187.953 55.9603 172.32 50.6854C154.076 44.5287 135.092 41.8336 116.001 45.1633C72.8375 52.6882 39.4298 82.8372 8.37658 111.577C10.5006 115.088 12.6328 118.599 14.7568 122.118V104.662C14.7568 101.719 13.8759 93.7495 9.65263 93.7001C5.42933 93.6506 5.0918 102.478 5.0918 104.901V122.357C5.0918 123.544 7.20756 136.847 11.472 132.899C37.4046 108.898 64.4156 83.9499 98.3666 72.065C130.869 60.6829 166.516 66.139 195.881 83.6367C207.193 90.3703 218.949 99.9887 223.361 112.838C223.617 113.571 223.757 114.387 224.036 115.113C225.403 118.681 223.995 112.22 224.036 113.629C224.102 115.788 225.057 107.621 224.193 110.365C224.078 110.736 223.822 111.989 223.79 112.129C222.9 115.236 221.443 118.253 219.739 120.989C215.985 127.022 211.095 132.116 205.538 136.5C193.346 146.119 178.609 152.605 163.75 156.792C146.461 161.655 128.654 162.594 111.078 158.712C71.8084 150.042 40.7799 121.665 12.1389 95.1589C5.3717 88.8785 3.09129 110.118 7.71798 114.404Z"
          fill="#164356"
        />
        <Path
          d="M179.432 113.497C179.457 111.264 179.169 115.137 179.432 113.538C178.905 116.777 179.729 112.483 179.078 115.673C178.683 117.585 178.074 119.423 177.35 121.245C175.662 125.522 173.241 129.437 170.302 132.965C164.713 139.665 157.369 144.676 149.046 147.314C131.963 152.745 112.773 147.833 100.663 134.564C95.2463 128.629 91.4017 121.294 90.1338 113.538C90.3973 115.137 90.1338 111.264 90.1338 113.497C90.1338 115.731 90.3973 111.857 90.1338 113.456C90.3808 111.956 90.636 110.423 91.1218 108.824C92.3484 104.752 94.2666 100.912 96.6787 97.4254C106.895 82.6476 124.933 75.1556 142.633 78.131C152.38 79.7711 161.337 84.502 168.162 91.6478C171.546 95.1918 174.476 99.2798 176.493 103.763C177.432 105.857 178.247 108.016 178.815 110.25C178.7 109.788 179.391 113.052 179.268 112.351C179.317 112.665 179.432 114.981 179.416 113.505C179.432 115.055 179.243 124.632 181.861 124.632C184.479 124.632 184.314 114.511 184.306 113.505C184.158 100.986 182.083 88.5158 175.341 77.7601C169.907 69.0813 161.601 62.2982 152.1 58.5317C132.276 50.6689 108.986 57.6086 96.3083 74.6776C89.2036 84.2383 86.1081 95.9336 85.4084 107.695C84.651 120.445 86.0423 133.871 92.0026 145.344C101.898 164.408 123.616 175.32 144.798 170.696C155.863 168.281 166.054 161.77 172.912 152.753C181.507 141.446 184.133 127.418 184.306 113.497C184.322 111.956 184.454 102.371 181.861 102.371C179.268 102.371 179.424 112.483 179.416 113.497H179.432Z"
          fill="#164356"
        />
        <Path
          d="M134.787 144.659C151.979 144.659 165.915 130.707 165.915 113.497C165.915 96.286 151.979 82.334 134.787 82.334C117.596 82.334 103.66 96.286 103.66 113.497C103.66 130.707 117.596 144.659 134.787 144.659Z"
          fill="#164356"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="clip0_5102_19355">
        <Rect fill="white" height="240" width="240" />
      </ClipPath>
      <ClipPath id="clip1_5102_19355">
        <Rect
          fill="white"
          height="139.503"
          transform="translate(5.0918 43.7207)"
          width="228.519"
        />
      </ClipPath>
    </Defs>
  </Svg>
);

export default EyeIllustrationSVG;
